import { FunctionComponent } from 'react';

import { TypeTextChildProps } from './types';

export const Title: FunctionComponent<TypeTextChildProps> = ({
  className = '',
  children,
}: TypeTextChildProps): JSX.Element => <p className={className}>{children}</p>;
